// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1UjFF","content":"ManualTimeModal_content__1eaRE"};